import * as actionTypes from "./actionTypes";
// import { workoutPlans } from "../../data";
import { firebase } from "../../firebase/index";
import {
  collections,
  documents,
  constants,
} from "../../firebase/firestoreNameSpaces";
import {
  generateUniqueId,
  getEmbedUrlFromYoutubeUrl,
  getYoutubeVideoId,
  sortArrayObjects,
} from "../utility";

const checkWorkoutPlanExist = (workouts, workoutPlanName) => {
  return workouts.filter(
    (obj) =>
      obj.title.toLowerCase().trim() == workoutPlanName.toLowerCase().trim()
  ).length;
};
const checkWorkoutExist = (workouts, newworkoutTitle) => {
  return workouts.filter(
    (workout) =>
      workout.title.toLowerCase().trim() ===
      newworkoutTitle.trim().toLowerCase()
  ).length;
};

const checkPlanExists = (editedPlan, actualPlans) => {
  return actualPlans.filter(
    (plan) =>
      plan.title.toLowerCase().trim() === editedPlan.title.trim().toLowerCase()
  ).length;
};

export const fetchWorkoutPlansClient = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { workoutsLoading: true },
      });

      let workoutPlans = [];
      let db = firebase.firestore();
      let snapshot = await db
        .collection(collections.K5METADATA)
        .doc(documents.WORKOUTS)
        .get();
      let data = snapshot.data();
      for (let docKey in data) {
        let category = data[docKey];
        let subcategory = [];
        if (category.workouts) {
          for (let skey in category.workouts) {
            subcategory.push(category.workouts[skey]);
          }
          category.workouts = sortArrayObjects(subcategory, "title");
          subcategory = [];
        }
        workoutPlans.push(category);
        workoutPlans = sortArrayObjects(workoutPlans, "title");
      }

      dispatch({
        type: actionTypes.FETCH_WORKOUT_PLANS,
        payload: { workouts: workoutPlans, workoutsLoading: false },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WORKOUT_PLANS,
        payload: { workouts: [], workoutsLoading: false },
      });
      return alert(error);
    }
  };
};

export const fetchWorkoutPlans = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { workoutsLoading: true },
      });

      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.WORKOUTS)
        .onSnapshot((snapshot) => {
          let fetched_plans = [];
          let data = snapshot.data();
          for (let docKey in data) {
            let category = data[docKey];
            let subcategory = [];
            if (category.workouts) {
              for (let skey in category.workouts) {
                subcategory.push(category.workouts[skey]);
              }
              category.workouts = sortArrayObjects(subcategory, "title");

              subcategory = [];
            } else {
              category.workouts = [];
            }
            fetched_plans.push(category);
          }
          fetched_plans = sortArrayObjects(fetched_plans, "title");
          // console.log("Fecth WorkoutPlan Admin",fetched_plans)
          dispatch({
            type: actionTypes.FETCH_WORKOUT_PLANS,
            payload: { workouts: fetched_plans, workoutsLoading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WORKOUT_PLANS,
        payload: { workouts: [], workoutsLoading: false },
      });
      return alert(error);
    }
  };
};
export const fetchSpecificWorkout = (workoutname, workoutId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { workoutsLoading: true },
      });

      let db = firebase.firestore();
      let data = (
        await db.collection(collections.WORKOUTS).doc(workoutId).get()
      ).data();

      if (data) {
        let workouts = [];
        for (let wk in data.workouts) {
          workouts.push(data.workouts[wk]);
        }
        data.workouts = sortArrayObjects(workouts, "title");
        dispatch({
          type: actionTypes.FETCH_WORKOUT_PLANS,
          payload: { specificWorkout: data, workoutsLoading: false },
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_WORKOUT_PLANS,
          payload: { specificWorkout: [], workoutsLoading: false },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WORKOUT_PLANS,
        payload: { specificWorkout: null, workoutsLoading: false },
      });
      return alert(error);
    }
  };
};

export const fetchSpecificWorkoutAdmin = (workoutname, workoutId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { workoutsLoading: true },
      });

      let db = firebase.firestore();
      await db
        .collection(collections.WORKOUTS)
        .doc(workoutId)
        .onSnapshot((snapshot) => {
          let data = snapshot.data();
          if (data) {
            let workouts = [];
            for (let wk in data.workouts) {
              workouts.push(data.workouts[wk]);
            }
            data.workouts = sortArrayObjects(workouts, "title");
            dispatch({
              type: actionTypes.FETCH_WORKOUT_PLANS,
              payload: { specificWorkout: data, workoutsLoading: false },
            });
          } else {
            dispatch({
              type: actionTypes.FETCH_WORKOUT_PLANS,
              payload: { specificWorkout: [], workoutsLoading: false },
            });
          }
        });
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_WORKOUT_PLANS,
        payload: { specificWorkout: null, workoutsLoading: false },
      });
      return alert(error);
    }
  };
};

export const addWorkoutPlan = (plan, workout_plans) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: true },
      });

      if (checkWorkoutPlanExist(workout_plans, plan.title)) {
        dispatch({
          type: actionTypes.WORKOUT_CONTROLS,
          payload: { addPlanLoading: false },
        });
        return alert("Workout Plan Exist. Please Enter different title");
      }

      let db = firebase.firestore();
      const batch = db.batch();

      let categoryId = db.collection(collections.WORKOUTS).doc().id;
      plan["id"] = categoryId;

      let c1 = db.collection(collections.WORKOUTS).doc(categoryId);
      batch.set(c1, plan);
      let c2 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(c2, { [categoryId]: plan }, { merge: true });

      await batch.commit();

      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: false },
      });
      return alert("Workout Plan Added Successfully...");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: false },
      });
      return alert(error);
    }
  };
};

export const onEditPlan = (editedPlan, actualPlans) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editBtnLoading: true },
      });
      actualPlans = actualPlans.filter((pl) => {
        if (pl.id != editedPlan.id) {
          return true;
        }
      });

      if (checkPlanExists(editedPlan, actualPlans)) {
        dispatch({
          type: actionTypes.WORKOUT_CONTROLS,
          payload: { editBtnLoading: false },
        });
        return alert("Plan Exists. Please choose a different plan title");
      }

      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(
        c1,
        { [editedPlan.id]: { title: editedPlan.title, desc: editedPlan.desc } },
        { merge: true }
      );
      let c2 = db.collection(collections.WORKOUTS).doc(editedPlan.id);
      batch.set(
        c2,
        { title: editedPlan.title, desc: editedPlan.desc },
        { merge: true }
      );
      await batch.commit();

      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editBtnLoading: false },
      });
      return alert("Plan Updated Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editBtnLoading: false },
      });

      return alert(error);
    }
  };
};

export const onDeletePlan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { deleteBtnLoading: true },
      });

      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(
        c1,
        { [id]: firebase.firestore.FieldValue.delete() },
        { merge: true }
      );
      let c2 = db.collection(collections.WORKOUTS).doc(id);
      batch.delete(c2);
      document.getElementById(`delete${id}`).click();
      await batch.commit();
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { deleteBtnLoading: false },
      });

      return alert("Plan Deleted Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { deleteBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onAddWorkout = (workout, plan) => {
  return async (dispatch) => {
    try {
      let newSubcategory = workout.title;
      let url = getEmbedUrlFromYoutubeUrl(workout.url);
      if (!url) {
        return alert("Youtube Video Id is null");
      }
      workout.url = url.trim();
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addWorkoutLoading: true },
      });
      let workoutPlan = plan;
      //############################################

      //Avoid Subcategory duplicates
      if (workoutPlan.workouts) {
        let exists = checkWorkoutExist(workoutPlan.workouts, newSubcategory);
        if (exists) {
          dispatch({
            type: actionTypes.WORKOUT_CONTROLS,
            payload: { addWorkoutLoading: false },
          });
          return alert("Workout already exists. Please Try some other Title");
        }
      }

      let categoryId = workoutPlan.id;
      const db = firebase.firestore();
      const batch = db.batch();
      let subcategoryId =
        db.collection(collections.WORKOUTS).doc().id + generateUniqueId(4);
      //Adding to array in metadata
      let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(
        c1,
        {
          [categoryId]: {
            [constants.WORKOUTS]: {
              [subcategoryId]: {
                id: subcategoryId,
                title: newSubcategory,
                url: url,
              },
            },
          },
        },
        { merge: true }
      );
      //let categoryId = db.collection(collections.CATEGORIES).doc().id;
      // Adding to categories collection

      let c2 = db.collection(collections.WORKOUTS).doc(categoryId);
      batch.set(
        c2,
        {
          [constants.WORKOUTS]: {
            [subcategoryId]: {
              id: subcategoryId,
              title: newSubcategory,
              url: url,
            },
          },
        },
        { merge: true }
      );

      await batch.commit();
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addWorkoutLoading: false },
      });
      return alert("Workout Added Successfully...");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addWorkoutLoading: false },
      });
      return alert(error);
    }
  };
};

export const onEditWorkout = (editedWorkout, plan) => {
  return async (dispatch) => {
    try {
      let url = getEmbedUrlFromYoutubeUrl(editedWorkout.url);
      if (!url) {
        return alert("Youtube Video Id is null");
      }
      editedWorkout.url = url.trim();

      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editWorkoutLoading: true },
      });

      let subcategory = editedWorkout; //The edited one

      let category = plan;
      let categoryId = category.id;
      let subcategoryId = subcategory.id;
      //###################
      // if(checkWorkoutExist(category.workouts,newsubcategoryname)){
      //     return alert("Please Enter different Workout Tit")
      // }

      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(
        c1,
        {
          [categoryId]: {
            [constants.WORKOUTS]: { [subcategoryId]: subcategory },
          },
        },
        { merge: true }
      );
      let c2 = db.collection(collections.WORKOUTS).doc(categoryId);
      batch.set(
        c2,
        { [constants.WORKOUTS]: { [subcategoryId]: subcategory } },
        { merge: true }
      );
      await batch.commit();
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editWorkoutLoading: false },
      });
      return alert("Workout Edited Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { editWorkoutLoading: false },
      });
      return alert(error);
    }
  };
};

export const onDeleteWorkout = (workoutId, planId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { deleteWorkoutLoading: true },
      });

      let categoryId = planId;

      let subcategoryId = workoutId;
      //######################

      let db = firebase.firestore();
      let batch = db.batch();

      let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
      batch.set(
        c1,
        {
          [categoryId]: {
            [constants.WORKOUTS]: {
              [subcategoryId]: firebase.firestore.FieldValue.delete(),
            },
          },
        },
        { merge: true }
      );
      let c2 = db.collection(collections.WORKOUTS).doc(categoryId);
      batch.set(
        c2,
        {
          [constants.WORKOUTS]: {
            [subcategoryId]: firebase.firestore.FieldValue.delete(),
          },
        },
        { merge: true }
      );
      document.getElementById(`delete${workoutId}${planId}`).click();
      await batch.commit();
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { deleteWorkoutLoading: false },
      });
      return alert("Workout Deleted Successfully");
    } catch (error) {
      return alert(error);
    }
  };
};
